module.exports = __webpack_public_path__ + "static/media/7_analytics.4cdf869d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/7_analytics.mp4
// module id = 323
// module chunks = 0